import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

function formatDetail(d) {
    if (!d) return "";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return d?.msg || JSON.stringify(d);
}

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [err, setErr] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success("Benvingut!");
            navigate("/admin");
        } catch (e) {
            const msg = formatDetail(e?.response?.data?.detail) || "Credencials invàlides";
            setErr(msg);
            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-brand-navy/10 p-8 md:p-10">
                <Link to="/" className="font-display text-3xl text-brand-navy block text-center mb-1">Zarautz</Link>
                <div className="text-xs uppercase tracking-[0.25em] text-brand-blue text-center mb-8">Administració</div>
                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-brand-terracotta/10 mx-auto mb-6">
                    <Lock size={22} className="text-brand-terracotta" />
                </div>
                <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-brand-navy block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 focus:border-brand-terracotta focus:outline-none focus:ring-2 focus:ring-brand-terracotta/20"
                            data-testid="login-email"
                            autoFocus
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.2em] text-brand-navy block mb-2">Contrasenya</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg border border-brand-navy/20 focus:border-brand-terracotta focus:outline-none focus:ring-2 focus:ring-brand-terracotta/20"
                            data-testid="login-password"
                        />
                    </div>
                    {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
                    <button type="submit" disabled={submitting} className="btn-primary w-full justify-center mt-2" data-testid="login-submit">
                        {submitting ? "Entrant..." : "Entrar"}
                    </button>
                </form>
            </div>
        </div>
    );
}
